import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { usePlatformAdminUsersApi } from 'services/admin/usePlatformAdminUsersApi';

export const PLATFORM_ADMIN_USERS_QUERY_KEY = 'platform-admin-users';

export type PlatformAdminRoleFilter = 'all' | 'platformAdministrator';

export const useSearchPlatformAdminUsers = (
  search: string,
  page: number,
  count: number,
  roleFilter: PlatformAdminRoleFilter = 'all'
) => {
  const { searchUsers } = usePlatformAdminUsersApi();
  const platformAdministrator =
    roleFilter === 'platformAdministrator' ? true : undefined;

  return useQuery({
    queryKey: [PLATFORM_ADMIN_USERS_QUERY_KEY, search, page, count, roleFilter],
    queryFn: () =>
      searchUsers(search || undefined, page, count, platformAdministrator),
    placeholderData: keepPreviousData
  });
};
